'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$0024anon$0024160 from "./presto.types$$anon$160.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dError$002dPayload$0024 from "./presto.types$-Two-Factor-Auth-Error-Payload$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$TwoFactorAuthPayload$$anon$159() {
  this.cdR = null;
  this.cdJ = null;
  this.cdK = false;
  this.cdS = null;
  this.cdT = false;
  this.cdW = null;
  this.cdP = null;
  this.cdQ = false;
  this.cdL = null;
  this.cdM = false;
  this.cdN = null;
  this.cdO = false;
  this.cdU = false;
  this.cdV = false;
  this.cdR = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.cdW = "TwoFactorAuthErrorPayload";
}
export { $c_Lpresto_types$TwoFactorAuthPayload$$anon$159 as $c_Lpresto_types$TwoFactorAuthPayload$$anon$159 };
$p = $c_Lpresto_types$TwoFactorAuthPayload$$anon$159.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$TwoFactorAuthPayload$$anon$159;
/** @constructor */
function $h_Lpresto_types$TwoFactorAuthPayload$$anon$159() {
}
export { $h_Lpresto_types$TwoFactorAuthPayload$$anon$159 as $h_Lpresto_types$TwoFactorAuthPayload$$anon$159 };
$h_Lpresto_types$TwoFactorAuthPayload$$anon$159.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.cdR;
});
$p.M = (function() {
  if ((!this.cdK)) {
    this.cdJ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.cdK = true;
  }
  return this.cdJ;
});
$p.O = (function() {
  if ((!this.cdT)) {
    this.cdS = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.cdT = true;
  }
  return this.cdS;
});
$p.D = (function() {
  return this.cdW;
});
$p.t = (function() {
  if ((!this.cdQ)) {
    this.cdP = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("message", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.cdQ = true;
  }
  return this.cdP;
});
$p.N = (function() {
  if ((!this.cdM)) {
    this.cdL = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.cdM = true;
  }
  return this.cdL;
});
$p.Q = (function() {
  if ((!this.cdO)) {
    this.cdN = new $j_presto$002etypes$0024$0024anon$0024160.$c_Lpresto_types$$anon$160();
    this.cdO = true;
  }
  return this.cdN;
});
$p.v = (function() {
  if ((!this.cdV)) {
    this.cdU = false;
    this.cdV = true;
  }
  return this.cdU;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee183) => ((p) => \u03b4scrutinee183.cHD(p)))($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dError$002dPayload$0024.$m_Lpresto_types$TwoFactorAuthErrorPayload$())));
});
var $d_Lpresto_types$TwoFactorAuthPayload$$anon$159 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TwoFactorAuthPayload$$anon$159, "presto.types$TwoFactorAuthPayload$$anon$159", ({
  a2x: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_types$TwoFactorAuthPayload$$anon$159 as $d_Lpresto_types$TwoFactorAuthPayload$$anon$159 };
//# sourceMappingURL=presto.types$-Two-Factor-Auth-Payload$$anon$159.js.map
